import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Checkbox } from "./ui/checkbox";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NotifyPrefsMatrix = ({ categories, title = "Notification Preferences" }) => {
  const [prefs, setPrefs] = useState(null);

  useEffect(() => {
    axios.get(`${API}/notify/prefs`, { withCredentials: true })
      .then((res) => setPrefs(res.data.prefs || {}))
      .catch(() => setPrefs({}));
  }, []);

  const toggle = async (key, channel) => {
    const cur = prefs[key] || {};
    const next = { ...prefs, [key]: { ...cur, [channel]: !(cur[channel] ?? true) } };
    setPrefs(next);
    try {
      await axios.put(`${API}/notify/prefs`, { prefs: next }, { withCredentials: true });
      toast.success("Preferences saved");
    } catch {
      toast.error("Could not save preferences");
    }
  };

  if (!prefs) return null;

  return (
    <div className="bg-[#121212] border border-zinc-800 rounded-xl p-6" data-testid="notify-prefs-matrix">
      <h3 className="font-heading font-semibold text-white mb-4">{title}</h3>
      <div className="grid grid-cols-[1fr_auto_auto_auto] gap-x-5 gap-y-2 text-sm items-center">
        <div /><div className="text-zinc-500 text-xs">In-app</div><div className="text-zinc-500 text-xs">Push</div><div className="text-zinc-500 text-xs">Email</div>
        {categories.map(([key, label]) => {
          const p = prefs[key] || {};
          return [
            <div key={`${key}-l`} className="text-zinc-300">{label}</div>,
            <Checkbox key={`${key}-a`} data-testid={`prefs-${key}-in_app`} checked={p.in_app ?? true} onCheckedChange={() => toggle(key, "in_app")} />,
            <Checkbox key={`${key}-p`} data-testid={`prefs-${key}-push`} checked={p.push ?? true} onCheckedChange={() => toggle(key, "push")} />,
            <Checkbox key={`${key}-e`} data-testid={`prefs-${key}-email`} checked={p.email ?? true} onCheckedChange={() => toggle(key, "email")} />,
          ];
        })}
      </div>
    </div>
  );
};
